<template>

  <b-row>

    <b-col lg="5" md="6">
       <auto-form origin="define/source/faqs" v-model="currentID"></auto-form>
    </b-col>

  </b-row>


</template>
<script>
  export default {
    name: 'FaqsDetail',
    data(){
      return  {
        currentID: null
      }
    },
    beforeMount(){
      this.currentID = this.$route.params.id
    }
  }
</script>
